import localStreamingData from '../data/streaming.json';

let cachedData = null;

export const getAdaptedData = async () => {
    if (cachedData) return cachedData;
    
    let rawData;
    try {
        const response = await fetch('https://psflix.com.br/ps-flix-app/streaming.json');
        if (!response.ok) {
            throw new Error('Failed to fetch streaming data');
        }
        rawData = await response.json();
    } catch (err) {
        console.warn("CORS/Fetch error, falling back to local streaming.json:", err);
        rawData = localStreamingData;
    }

    cachedData = rawData.map(item => ({
        ...item,
        name: item.title,
        backdrop_path: item.bannerPath.replace(/^\//, ''),
        poster_path: item.cardPath.replace(/^\//, ''),
        overview: item.description,
        release_date: item.year,
        videoPath: item.videoPath,
        genre_ids: item.displayGenre ? item.displayGenre.split(' / ') : []
    }));
    
    return cachedData;
};
